import { useSite } from "../context/SiteContext";
import { mediaSrc } from "./api";

const FALLBACK_LOGO = `${process.env.PUBLIC_URL || ""}/brand/logo-480.webp`;

// Client-supplied brand imagery from the media library: { src, srcSet, width, height } for the given key.
export function useBrandImage(key) {
  const site = useSite() || {};
  const list = site.brand?.[key] || [];
  if (!list.length) return key === "logo" ? { src: FALLBACK_LOGO, srcSet: undefined, width: 480, height: 182 } : null;
  const largest = list[list.length - 1];
  return {
    src: mediaSrc(largest.image_url),
    srcSet: list.map((v) => `${mediaSrc(v.image_url)} ${v.w}w`).join(", "),
    width: largest.w,
    height: largest.h,
  };
}

// CMS images still flagged TEMPORARY (stock) are replaced by the client artwork in banners.
export function useIsTemporary() {
  const site = useSite() || {};
  const temp = new Set(site.temporary_media || []);
  return (url) => !url || temp.has(url);
}
